export default "__VITE_ASSET__DaZt3rPv__"